import React, { useState } from 'react';
import { Box, Stack, Typography, TextField, Button } from '@mui/material';

interface PasswordGateProps {
  children: React.ReactNode;
}

const PasswordGate: React.FC<PasswordGateProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

  const BRAND_GREEN = '#34de9aab';

  const handleCheck = () => {
    // You can change this to your desired deployment password
    if (password === 'heremaimailight') { 
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
    }
  };

  if (isAuthenticated) return <>{children}</>;

  return (
    <Box 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        bgcolor: '#f0fff9' 
      }}
    >
      <Stack 
        spacing={3} 
        sx={{ 
          p: 4, 
          bgcolor: 'white', 
          borderRadius: 4, 
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)', 
          border: `1px solid ${BRAND_GREEN}`,
          width: '100%',
          maxWidth: 400,
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" sx={{ color: BRAND_GREEN, fontWeight: 'bold' }}>
          Private Deployment
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please enter the access code to view the heremaimai platform.
        </Typography>
        <TextField 
          fullWidth
          type="password" 
          label="Access Code" 
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleCheck()}
          sx={{
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: BRAND_GREEN,
              },
            },
          }}
        />
        <Button 
          fullWidth
          variant="contained" 
          onClick={handleCheck} 
          sx={{ 
            bgcolor: BRAND_GREEN, 
            py: 1.5,
            fontWeight: 'bold',
            '&:hover': { bgcolor: '#2bc48a' } 
          }}
        >
          Enter Site
        </Button>
      </Stack>
    </Box>
  );
};

export default PasswordGate;